import Environment, { baseUrl } from "./Environment";

class FinancialStatementService {
    async getFinancialStatementYears(params) {
        const response = await Environment.get(`${baseUrl}/api/financial-statements?${params}&populate=*`)
            .then((response) => {
                return response.data;
            })
            .catch((error) => ({ error: JSON.stringify(error) }));
        return response;
    }

    async getFinancialStatementByYear(payload) {
        const response = await Environment.get(`${baseUrl}/api/financial-statements?${payload}`)
            .then((response) => {
                return response.data;
            }).catch((error) => ({ error: JSON.stringify(error) }));
        return response;
    }
}

export default new FinancialStatementService();